module.exports = __webpack_public_path__ + "static/media/new-capa1.6f224fcf.png";